import * as React from 'react';

import { cn } from '@/lib/utils';
import { Input } from './input';

const ICON_SLOT_WIDTH = 'w-11';

const IconInput = React.forwardRef(
  (
    {
      icon: Icon,
      iconSize = 18,
      trailing,
      containerClassName,
      iconClassName,
      className,
      variant = 'elite',
      ...props
    },
    ref
  ) => {
    const isElite = variant === 'elite';

    return (
      <div className={cn('relative', containerClassName)}>
        <span
          className={cn(
            'pointer-events-none absolute inset-y-0 left-0 z-[1] flex',
            ICON_SLOT_WIDTH,
            'items-center justify-center text-slate-400 dark:text-[#93AE9F]',
            iconClassName
          )}
          aria-hidden="true"
        >
          <Icon size={iconSize} />
        </span>
        <Input
          ref={ref}
          className={cn(
            isElite && 'elite-input elite-input--leading-icon',
            !isElite && 'pl-11',
            trailing && isElite && 'elite-input--trailing-icon',
            trailing && !isElite && 'pr-11',
            className
          )}
          {...props}
        />
        {trailing}
      </div>
    );
  }
);

IconInput.displayName = 'IconInput';

export { IconInput };
